import { useState, useCallback, useRef } from "react";
import { downloadAnalyticsCsvFromApi } from "utils/analytics/analyticsDownload";
import { trackAnalyticsReportDownloaded } from "utils/Tracking";
import { DateRange, Filters } from "utils/analytics/types";

type DownloadType = "domain_analytics" | "error_logs";

interface UseAnalyticsDownloadOptions {
  dateRange: DateRange;
  filters?: Filters;
  filenamePrefix: string;
  type?: "domains" | "error-logs";
  extraParams?: Record<string, any>;
  trackingEvent?: DownloadType;
}

export const useAnalyticsDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const isDownloadingRef = useRef(false);

  const download = useCallback(
    async (options: UseAnalyticsDownloadOptions) => {
      if (isDownloadingRef.current) return;

      isDownloadingRef.current = true;
      setIsDownloading(true);
      try {
        await downloadAnalyticsCsvFromApi({
          dateRange: options.dateRange,
          filters: options.filters,
          filenamePrefix: options.filenamePrefix,
          type: options.type,
          extraParams: options.extraParams,
        });

        if (options.trackingEvent) {
          trackAnalyticsReportDownloaded(options.trackingEvent);
        }
      } catch (_) {
        // Error toast already handled by downloadAnalyticsCsvFromApi
      } finally {
        isDownloadingRef.current = false;
        setIsDownloading(false);
      }
    },
    []
  );

  return {
    download,
    isDownloading,
  };
};
